import React from "react";
import CloseModalIconSVG from "../../assets/icons/svg/CloseModalIconSVG";

const BaseModal = ({
    children,
    open,
    setOpen,
    externalStyle = {}
}) => {

    if (!open) {
        return null;
    };

    const getDialogStyle = () => {
        return {
            ...styles.dialogStyle,
            ...externalStyle
        };
    };

    return (
        <div
            style={styles.overlay}
            onClick={() => setOpen(false)}
        >
            <dialog
                open={open}
                style={getDialogStyle()}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    onClick={() => setOpen(false)}
                    style={styles.closeIconContainer}
                >
                    <CloseModalIconSVG />
                </div>

                {children}
            </dialog>
        </div>
    );
};

export default BaseModal;

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
    },
    dialogStyle: {
        border: "none",
        borderRadius: "8px",
        paddingTop: "40px",
        paddingBottom: "80px",
        paddingInline: "20px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    closeIconContainer: {
        cursor: "pointer",
        position: "absolute",
        top: 10,
        right: 16,
    }
}